<template>
    <div
        class="product-selection"
        role="group"
    >
        <DFormRow
            :label="__('products.products.form.product_addon')"
            is-required
            :error="errors.product_group_id"
        >
            <DFieldLoading
                v-if="isLoadingProducts"
                :is-loading="isLoadingProducts"
            />
            <div
                v-else
                style="display: flex; align-items: center; width: 100%;"
            >
                <DSelect
                    id="dropdown-product-group"
                    v-model="selectValue"
                    style="flex-grow: 1"
                    :options="products"
                    :placeholder="__('products.products.form.product_addon')"
                    :disabled="isPreLiveContract === false || isLoadingProducts"
                    @update:value="handleProductChange"
                />
                <div style="display: flex; align-items: center; flex-shrink: 0; margin-left: 10px">
                    <DSwitch
                        v-model="displayRetiredProducts"
                        color="success"
                        variant="3d"
                        :disabled="isLoadingProducts"
                        @update:checked="handleRetiredChange"
                    />
                    <label style="margin-bottom: 0; padding-left: 5px;">
                        {{ __('products.products.form.also_display_retired_addons') }}
                    </label>
                </div>
            </div>
        </DFormRow>
    </div>
</template>

<script setup>

import DFieldLoading from '~@/Components/Common/DFieldLoading'

import { onMounted, ref } from 'vue'
import { route } from '~@/Composables/route'

const props = defineProps({
    contract: {
        type: Object,
        default: () => { return {} }
    },
    form: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    customer: {
        type: Object,
        default: () => { return {} }
    },
    isLoadingContractOptions: {
        type: Boolean,
        default: false
    },
    addonProducts: {
        type: Boolean,
        default: false
    },
    isPreLiveContract: {
        type: Boolean,
        default: false
    }
})

const products = ref([])
const selectedProduct = ref(null)
const isLoadingProducts = ref(false)
const displayRetiredProducts = ref(false)
const selectValue = ref(0)

const emit = defineEmits(['productDeselected', 'updateProductId'])

onMounted(() => {
    fetchProducts()
})

function fetchProducts () {
    const params = {
        retired: displayRetiredProducts.value ? 1 : 0,
        product: props.contract.product_id,
        contract: props.contract?.contract_id ? props.contract?.contract_id : props.contract?.parent?.id
    }

    isLoadingProducts.value = true

    window.axios.get(
        route('products.dropdown.product-addons-selection-list',
            params
        ))
        .then((response) => {
            products.value = response.data.items
            if (props.form.product_id) {
                products.value.forEach(item => {
                    if (item.value === parseInt(props.form.product_id)) {
                        selectValue.value = item.value
                    }
                })
            }
            isLoadingProducts.value = false
        })
}

function updateProduct (value) {
    if (value?.value === '') {
        emit('productDeselected')
    }

    products.value.forEach(item => {
        if (item.value === parseInt(value)) {
            selectedProduct.value = item
        }
    })

    if (Number(props.form.product_id) !== Number(value.value) && Number(value.value) !== 0) {
        emit('updateProductId', selectedProduct.value)
    }
}

function handleRetiredChange () {
    displayRetiredProducts.value = !displayRetiredProducts.value
    fetchProducts()
}

function handleProductChange (value) {
    updateProduct(value)
}
</script>
